import { render, staticRenderFns } from "./Stap4b.vue?vue&type=template&id=286c97f0&"
import script from "./Stap4b.vue?vue&type=script&lang=js&"
export * from "./Stap4b.vue?vue&type=script&lang=js&"
import style0 from "./Stap4b.vue?vue&type=style&index=0&id=286c97f0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports